import { render, staticRenderFns } from "./CampaignCardSkeleton.vue?vue&type=template&id=cc9d9f5e&scoped=true&"
import script from "./CampaignCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./CampaignCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CampaignCardSkeleton.vue?vue&type=style&index=0&id=cc9d9f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9d9f5e",
  null
  
)

export default component.exports